import { FC } from "react";
import { Image, Modal } from "react-bootstrap";
import importIcon from "../../../assets/images/importIcon.svg";
import ProgressBarComponent from "../progress-bar/progress-bar.component";

interface ProgressBarModalComponentProps {
  showModal: boolean;
  progress: number;
}

const ProgressBarModalComponent: FC<ProgressBarModalComponentProps> = ({
  showModal,
  progress,
}) => {
  return (
    <Modal show={showModal} size="xl" centered>
      <Modal.Body>
        <div style={{ padding: "0 1rem" }}>
          <div className="d-flex flex-column align-items-center">
            <div className="d-flex gap-3">
              <h2>Uploading</h2>
              <Image src={importIcon} alt="icon"></Image>
            </div>
            <p className="text-warning">Please do not leave the page</p>
          </div>
          <div className="py-5">
            <ProgressBarComponent progress={progress} />
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default ProgressBarModalComponent;
